import RadioButton from "../RadioButton"
import ProductDetails from "../ProductDetails"
/**
 * Select products for within a radio list
 *  
 */
const ProductRadioListItem = ({
    product={},
    defaultActiveVariantId="",
    showDescription=true,
    onChange=()=>{},
    onChangeActiveVariantId=()=>{},
    selected=""
}) => {
    if (!product) return null
    return (
        <div className={`display-flex align-items-center text-align-left width-100pct
                        border-bottom-width-1px border-bottom-color-grey border-bottom-style-solid
                        cursor-pointer padding-05em
                        hover-background-light-grey:hover
                        
        `}>
            <div>
                <RadioButton checked={selected} onChange={onChange}/>
            </div>
            <div className="max-width-90pct">
            <ProductDetails 
                product={product}
                defaultActiveVariantId={defaultActiveVariantId}
                showDescription={showDescription}
                onChangeActiveVariantId={onChangeActiveVariantId}
            />
            </div>
            
        </div>
    )
}

export default ProductRadioListItem